import { _js } from '@ifixit/localize';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const LinkButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().editLink().run()}
         isDisabled={!editor.can().editLink()}
         isActive={editor.isActive('link')}
         icon={<FontAwesomeIcon icon={faLink} />}
         title={_js('Insert a link')}
         shortcut={'k'}
      />
   );
};
